// 기능 노출 플래그
//
// 모듈B(3종 융합 판정) · 모듈C(HITL 자율 품질관리)는 현재 운영에서 사용하지 않는
// 제안서 목업 화면이라 배포 빌드에서는 메뉴와 라우트를 모두 감춘다.
//
// 판정 순서
//   1) REACT_APP_ENABLE_MODULES_BC 가 지정되어 있으면 그 값을 그대로 따른다.
//      - 배포 서버에서 임시로 열어보려면 빌드 시 'true'
//      - 로컬에서 배포와 동일하게 감춰서 확인하려면 'false'
//   2) 지정이 없으면 개발 서버(npm start)에서만 노출한다.
//      배포는 react-scripts build(NODE_ENV=production)로 나가므로 자동으로 감춰진다.
//
// 로컬 설정은 .env.local 에 넣으면 된다 (.gitignore 에 포함되어 커밋되지 않음).
//   REACT_APP_ENABLE_MODULES_BC=true
const flag = process.env.REACT_APP_ENABLE_MODULES_BC;

export const MODULES_BC_ENABLED =
  flag !== undefined && flag !== ''
    ? flag === 'true'
    : process.env.NODE_ENV === 'development';

// 데이터 출처(데모 공정·데모 카메라·데모 판정, 현장 IV4 수신) 표시 — 품질·생산 > 샷동기화·비전검사·융합검사.
// 기본은 숨김(2026-10-29 요청). 다시 보이려면 빌드 시 REACT_APP_SHOW_DATA_SOURCE=true
export const SHOW_DATA_SOURCE = process.env.REACT_APP_SHOW_DATA_SOURCE === 'true';
